module.exports = __webpack_public_path__ + "static/media/9DESA23.9a8d5eb5.jpg";